import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Channel } from "types";
import Icon from "@/icons";

export default function NSFWAlert({
    setIsNsfwAccepted,
    channel
}: {
    setIsNsfwAccepted: any;
    channel: Channel;
}) {
    const [isChecked, setIsChecked] = useState(false);

    const acceptNSFW = () => {
        if (isChecked) {
            setIsNsfwAccepted((prev: any) => {
                const newAccepted = [...prev, channel.id];
                localStorage.setItem("nsfwAcceptedChannels", newAccepted.join(","));
                return newAccepted;
            });
        }
    };

    return (
        <div className="flex flex-col relative items-center justify-center h-full w-full bg-gradient-to-br from-brand-profile to-red-400/10 select-none">
            <div className="flex flex-col items-center justify-center gap-4">
                <p className="text-gray-300 text-center text-8xl animate-pulse">
                    <span role="img" aria-label="Warning">
                        ⚠️
                    </span>
                </p>
                <h1 className="text-white font-semibold text-2xl flex items-center gap-2">
                    {channel.type === "text" && (
                        <Icon name="hashtag" size="24" color="#a3a3ac" />
                    )}
                    {channel.type === "todo" && (
                        <Icon name="todo" size="24" color="#a3a3ac" />
                    )}
                    {channel.type === "watchstream" && (
                        <Icon name="stream" size="24" color="#a3a3ac" />
                    )}
                    {channel.type === "voice" && (
                        <Icon name="volume" size="24" color="#a3a3ac" />
                    )}

                    {channel.name}
                </h1>
                <p className="text-gray-300 text-center">
                    This channel contains <strong className="text-red-400">NSFW</strong> content.
                    Are you sure you want to view this content?
                </p>
                <div className="flex items-center gap-2 mt-4">
                    <div
                        className={`w-6 h-6 border-2 rounded-lg ${isChecked ? "bg-brand-green border-brand-dark" : "border-brand-back"} transition-all duration-300 cursor-pointer`}
                        onClick={() => setIsChecked(!isChecked)}
                    >
                        {isChecked && (
                            <svg
                                className="w-5 h-5 text-white mx-auto my-auto"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                            </svg>
                        )}
                    </div>
                    <label htmlFor="ageCheck" className="text-gray-300 cursor-pointer" onClick={() => setIsChecked(!isChecked)}>
                        I am 18 years old or older
                    </label>
                </div>
            </div>
            <div className="flex items-center justify-center gap-4 mt-4">
                <Button className="bg-brand-dark rounded-lg" onClick={() => {
                    window.history.back();
                }}>
                    Go Back
                </Button>
                <Button className="bg-brand-dark rounded-lg" onClick={acceptNSFW} disabled={!isChecked}>
                    Go to Channel
                </Button>
            </div>
        </div>
    );
}
